export const RoutePaths = {
    HOME: "/",
    RESULTS: "/results",
    REWARDS: "/rewards",
    // TODO remove unused paths
    GAME_LAUNCH: "/game",
    GAME_LOBBY: "/game/:gameId",
    SPIN_WHEEL: "/spin-wheel",
};
